export const StaticData = {
  ROUTE_NAMES: {
    INFO: "Info",
    HELP: "Help",
    DETAIL: "Detail",
    QUERY: "Query",
    QUERY_APP: "QueryApp",
    FORMULAR: "Formular",
    WEBENTITY: "Webentity",
    DOCUMENT: "Document",
    PARAMETER: "Parameter",
    FRAMELINK: "Framelink",
    SINGLE_RECORD_VIEW: "SingleRecordView",
    RELEASE_NOTES: "ReleaseNotes",
    GMAP: "Gmap",
    CHART: "Chart",
    GANTT: "Gantt"
  },
  DATATYPES: {
    TYPE_STRING: 11,
    TYPE_INT: 1,
    TYPE_LINK: 12,
    TYPE_BOOLEAN: 6,
    TYPE_DATETIME: 21,
    TYPE_DATE: 22,
    TYPE_VALUELIST: 201,
    TYPE_AUTOCOMPLETE: 206,
    TYPE_LONG: 2,
    TYPE_INT64: 3,
    TYPE_FLOAT: 4,
    TYPE_DOUBLE: 5,
    TYPE_MEMO: 15,
    TYPE_RICHTEXT: 14,
    TYPE_STATIC_TEXT: 16,
    TYPE_TIME: 23,
    TYPE_TICKET: 108,
    TYPE_TOKEN: 109,
    TYPE_FILE: 210,
    TYPE_PHOTO: 212,
    TYPE_SIGNATURE_FIELD: 215,
    TYPE_INDIVIDUAL: 301,
    TYPE_SUBCLASS: 400,
    TYPE_BLOB: 500
  },
  VIEW_MODES: {
    UNDEFINED: 0,        // same as SIMPLE_LIST
    DETAILED: 1,         // CARDS
    SIMPLE_LIST: 2,
    SMALL_SYMBOLS: 3,    // CARDS without text
    BIG_SYMBOLS: 4,      // CARDS
    DASHBOARD: 5
  },
  VIEW_MODES_QUERY: {
    TABLE: 0,        // default
    CARD: 11         // Cards
  },
  QUERY_RENDERMODE: {
    CASUAL_LIST_RENDERER: 1,
    EAPPLICATION_RENDERER: 2
  },
  PROPERTY_TYPES: {
    PROP_TYPE_FORMULAR: 1,
    PROP_TYPE_PARAMETER: 2
  },
  DASHBOARD_MODES: {
    MODE_111: 111,
    MODE_211: 211,
    MODE_212: 212,
    MODE_221: 221,
    MODE_222: 222,
    MODE_1121: 1121
  },
  CHART_TYPE: {
    LINE: 1,
    BAR: 2,
    PIE: 4
  },
  QUERY_COMMAND_TYPES: {
    QUERY: 1,
    UPDATE: 2,
    PROC_CALL: 3,
    DOCUMENT: 4,
    FORMLINK: 5,
    FRAME: 6,
    CATEGORY: 7
  },
  FORM_MASTERPROPERTY_MODES: {
    NONE: 0,
    VISIBLE: 1,
    REQUIRED: 3,
    READONLY: 4
  },
  FORM_REQUIRED_MODES: {
    NONE: 0,
    EAGER: 1,
    LAZY: 2,
    ON_CHECKOUT: 11,
    ON_CLOSE: 12
  },
  SUBFORM_INITIAL_BEHAVIOR: {
    BUTTON_ONLY: 0,
    BUTTON_AND_FORM: 1
  },
  ACTION_POST_ACTION_BEHAVIOUR: {
    UNDEFINED: 0,
    QUERY_NEW_PARAMETERIZE: 1,
    QUERY_SHOW_UNCHANGED_RESULT: 2,
    QUERY_NEW_EXECUTE: 3,
    CALL_OTHER_QUERY: 4
  }
}

Object.freeze(StaticData)
